// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.header-search[data-v-39053375] {
  display: flex;
  justify-content: end;
  gap: 1px;
  flex-grow: 1;
  transition: all 0.2s linear;
  position: relative;
}
.header-search[data-v-39053375] .v-autocomplete {
  border-radius: 2px 0px 0px 2px;
}
.header-search[data-v-39053375] .v-input__control > .v-input__slot {
  margin-bottom: 0px;
}
.search-loader[data-v-39053375] {
  position: absolute;
  pointer-events: none;
  right: 45px;
  top: 0px;
}
.search-category[data-v-39053375] {
  width: 200px;
}
.search-category[data-v-39053375] .v-autocomplete {
  border-radius: 0px 2px 2px 0px;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
